// extracted by mini-css-extract-plugin
module.exports = {"value":"RadialProgressBar_value__LOiPU","number":"RadialProgressBar_number__kcegl","percentage":"RadialProgressBar_percentage__ChQ2_","label":"RadialProgressBar_label__WrOR1"};